import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';
import CSSModules from 'react-css-modules';

import Shape from '../../../common/Shape';
import Icon from '../../../Icon';
import { useDayPicker } from './useDayPicker';
import styles from './styles.styl';

function DayPicker({ activeDate, onChange, disabled }) {
  const {
    offset,
    options,
    disabledNext,
    disabledPrev,
    handleNext,
    handleBack,
    daysBoxRef,
  } = useDayPicker(activeDate);

  function printDateList() {
    return options.dateList.map(({ timestamp, dayText, dateText }) => {
      const active = activeDate === timestamp;

      return (
        <div
          onClick={() => onChange(timestamp)}
          styleName="DayItem"
          key={timestamp}
        >
          <div styleName={cn('DayItemWrapper', { active })}>
            <div styleName="DayItemDay">{dayText}</div>
            <div styleName="DayItemDate">{dateText}</div>
          </div>
        </div>
      );
    });
  }

  return (
    <Shape styleName={cn('DayPicker', { disabled })}>
      <div
        styleName={cn('DayPickerBack', { disabled: disabledPrev })}
        onClick={handleBack}
      >
        <Icon name="arrow-back" />
      </div>
      <div styleName="DayPickerContainer" ref={daysBoxRef}>
        <div
          styleName="DayPickerCarousel"
          style={{
            width: options.MAX_WIDTH,
            transform: `translate3d(${offset}px, 0, 0)`,
          }}
        >
          {printDateList()}
        </div>
      </div>
      <div
        styleName={cn('DayPickerNext', { disabled: disabledNext })}
        onClick={handleNext}
      >
        <Icon name="arrow-back" />
      </div>
    </Shape>
  );
}

DayPicker.propTypes = {
  onChange: PropTypes.func,
  activeDate: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CSSModules(DayPicker, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/Components/DayPicker/index.jsx